import { toast } from "react-toastify"

/**
 * show errors
 * @param {object} object
 */
export default function errorHandler(input) {
    if (Array.isArray(input)) {
        input.forEach((err) => toast.error(err?.message || "Unknown error"))
    } else if (typeof input === "object") {
        Object.values(input).forEach((val) => {
            if (Array.isArray(val)) {
                val.forEach((msg) => toast.error(msg))
            } else if (typeof val === "string") {
                toast.error(val)
            }
        })
    } else {
        toast.error("Unexpected error format")
    }
}
